import { pdfjs } from 'react-pdf';
import { getPdfWorkerPath } from './pdf-worker-config';

export function setupWorkers(): void {
    // Configure PDF.js worker for Arc PDFViewer component
    const workerPath = getPdfWorkerPath();
    if (workerPath) {
        pdfjs.GlobalWorkerOptions.workerSrc = workerPath;
    }
}
